document.addEventListener('DOMContentLoaded', function () {

    homeCardsTestimonials();

}, false);


function homeCardsTestimonials() {


    var slider = document.querySelector('.home-cards__slider');
    if( slider ){
        
        var slideObj = new Swiper(".home-cards__slider", {
            slidesPerView: 1,
            slidesPerGroup: 1,
            speed: 400,
            spaceBetween: 50,
            mousewheel: false,
            freeMode: false,
            grabCursor: true,
    
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: false,
            },
            autoplay: {
                delay: 3000,
            },
        });
        
    }

} 